import { z } from 'zod';
import { FileIdSchema, McpServerNameSchema } from '../ids.ts';

export const UntrustedEnvelopeSchema = z.object({
  source: z.string(),
  untrusted: z.literal(true),
  data: z.unknown(),
});
export type UntrustedEnvelope = z.infer<typeof UntrustedEnvelopeSchema>;

export const SpilledResultSchema = z.object({
  saved_to: z.string(),
  file_id: FileIdSchema,
  format: z.enum(['json', 'ndjson', 'csv', 'text', 'binary']),
  bytes: z.number().int().nonnegative(),
  rows: z.number().int().nonnegative().nullable(),
  columns: z.array(z.object({ name: z.string(), type: z.string() })).nullable(),
  preview: z.array(z.unknown()),
  truncated: z.boolean(),
});
export type SpilledResult = z.infer<typeof SpilledResultSchema>;

export const McpToolOutputSchema = z.object({
  content: z.array(z.looseObject({ type: z.string() })),
  structuredContent: z.unknown().optional(),
  isError: z.boolean(),
  plato: z.object({
    server: McpServerNameSchema,
    server_title: z.string().optional(),
    tool: z.string(),
    bytes: z.number().int().nonnegative(),
    inlined: z.boolean(),
    spilled: SpilledResultSchema.nullable(),
    saved_to: z.string().optional(),
    error_code: z.string().optional(),
  }),
});
export type McpToolOutput = z.infer<typeof McpToolOutputSchema>;
